import { Box } from '@mui/material'
import { useContext } from 'react'
import { Helmet } from 'react-helmet'

import { EntityCardInView, EntityListItemInView } from '../../Components'
import { EntityListContext, EntityListLoader, ListVariantComponentType, ListVariantContext, ListVariantLoader } from '../../Contexts'
import { EntityListHeader } from '../../Toolbar'
import WorldBasePage from '../WorldBasePage'

const SortedEntityCardList: React.FC = () => {
  const { sortedEntityList } = useContext(EntityListContext)

  const { size } = useContext(ListVariantContext)

  return (
    <Box display="flex" flexWrap="wrap" justifyContent="center">
      {sortedEntityList
        ? sortedEntityList?.map((sortableEntity) => {
            return (
              <Box display="flex" key={sortableEntity.entity.address.toString()} margin={0.5}>
                <EntityCardInView address={sortableEntity.entity.address} size={size} />
              </Box>
            )
          })
        : null}
    </Box>
  )
}

const SortedEntityBarList: React.FC = () => {
  const { sortedEntityList } = useContext(EntityListContext)

  return (
    <Box alignItems="stretch" display="flex" flexDirection="column" flexGrow={1}>
      {sortedEntityList
        ? sortedEntityList?.map((sortableEntity) => {
            return (
              <Box display="flex" flexGrow={1} key={sortableEntity.entity.address.toString()} margin={0.5}>
                <EntityListItemInView address={sortableEntity.entity.address} />
              </Box>
            )
          })
        : null}
    </Box>
  )
}

const SortedEntityList: React.FC = () => {
  const { componentType } = useContext(ListVariantContext)
  return (
    <Box display="flex" justifyContent="center">
      {(() => {
        switch (componentType) {
          case ListVariantComponentType.Bar:
            return <SortedEntityBarList />
          case ListVariantComponentType.Card:
            return <SortedEntityCardList />
          default:
            throw Error('Invalid ListVariantComponentType')
        }
      })()}
    </Box>
  )
}

const EntitiesPage: React.FC = () => {
  return (
    <WorldBasePage>
      <Helmet title="Entities List" />
      <Box display="flex" flexDirection="column" flexGrow={1}>
        <ListVariantLoader>
          <EntityListLoader>
            <EntityListHeader />
            <SortedEntityList />
          </EntityListLoader>
        </ListVariantLoader>
      </Box>
    </WorldBasePage>
  )
}

export default EntitiesPage
